export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;

const languageMap: Record<string, string> = {
    'en': 'en-US',
    'de': 'de-DE'
};

export const mapBackendLanguageToI18nLocale = (backendLanguage?: string): string => {
    if (!backendLanguage) return 'en-US';

    return languageMap[backendLanguage] || 'en-US';
};

export const mapDetectedLocaleToI18nLocale = (detectedLocale?: string): string => {
    return mapBackendLanguageToI18nLocale(detectedLocale?.toLowerCase().split(/[-_]/)[0]);
};

export const mapI18nLocaleToBackendLanguage = (i18nLocale?: string): string => {
    const locale = mapDetectedLocaleToI18nLocale(i18nLocale);
    return Object.keys(languageMap).find((language) => languageMap[language] === locale) ?? 'en';
};

export const isSupportedLanguage = (language: string): boolean => {
    return SUPPORTED_LANGUAGES.includes(language as typeof SUPPORTED_LANGUAGES[number]);
};
